import { render, staticRenderFns } from "./UserSegmentApp.vue?vue&type=template&id=0e799a9a&"
import script from "./UserSegmentApp.vue?vue&type=script&lang=js&"
export * from "./UserSegmentApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports